import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { MonetizationOn as MonetizationOnIcon } from "@mui/icons-material";

import { formatPrice } from "../../../utils/function";

const defaultTaxRate = 0.085;

const TotalsSummary = ({ data, direction = "vertical" }) => {
  const [summaryData, setSummaryData] = useState({
    subtotal: { title: "Subtotal", value: 0 },
    tax: { title: `Tax (${defaultTaxRate * 100}%)`, value: 0 },
    total: { title: "Total", value: 0 },
  });

  useEffect(() => {
    if (!data) return;

    const { unitMaterials, taxRate } = data;
    let subtotal = 0;
    let tax = 0;
    let total = 0;

    if (unitMaterials !== null) {
      subtotal += unitMaterials.reduce(
        (a, crItem) =>
          a + (Number(crItem.ITEM_QTY1) * Number(crItem.ITEM_COST) || 0),
        0
      );
    }
    tax = subtotal * taxRate; // will be some tax multiplier later identified
    total = subtotal + tax;

    setSummaryData({
      subtotal: { title: "Subtotal", value: subtotal },
      tax: { title: `Tax (${taxRate * 100}%)`, value: tax },
      total: { title: "Total", value: total },
    });
  }, [data]);

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <List sx={{ display: direction === "horizontal" && "flex" }}>
              {Object.keys(summaryData).map((key, index) => (
                <ListItem key={index}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "orange" }}>
                      <MonetizationOnIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${formatPrice(summaryData[key].value)}`}
                    secondary={summaryData[key].title}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TotalsSummary;
